import { useInfiniteQuery } from '@tanstack/react-query';
import { get } from 'lodash';
import { getArchivedOutliers } from '@src/api/aiRoadmapOutliers';
import { OutlierItemType } from '../ContentPanel/types';
import { defaultQuerySortBy } from '../ContentPanel/utils';
import { useAtom } from 'jotai';
import { archivedTabSearchTextAtom } from '../ContentPanel/atoms';

// TODO: add all search key options [dimension, summary, priority, status]
function useFetchArchivedOutliers({ sortBy = defaultQuerySortBy, searchKeys = ['dimension'] }) {
  const [searchText, setSearchText] = useAtom(archivedTabSearchTextAtom);
  const search = searchText ? searchKeys.map((key) => ({
    field: key,
    value: searchText,
  })): [];

  const fetchedObject = useInfiniteQuery(
    [sortBy, search],
    async ({ pageParam = [] }) => {
      const res = await getArchivedOutliers(
        {
          query: {
            sortBy: [sortBy],
            searchAfter: pageParam,
            search,
          },
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
          },
        }
      );

      const { feeds, searchAfter }: { feeds: OutlierItemType; searchAfter: number[]; } = get(res, ['data'], []);

      return { feeds, searchAfter };
    },
    {
      retry: false,
      refetchOnWindowFocus: false,
      cacheTime: 0, // to avoid multiple calls because of cached page params when component is remounted
      getNextPageParam: (res) => {
        const searchAfter: number[] = get(res, ['searchAfter'], []);
        return searchAfter.length > 0 ? searchAfter : [];
      },
    }
  );

  const {
    isLoading,
    data,
    isError,
    refetch,
    fetchNextPage,
    isFetchingNextPage,
  } = fetchedObject;

  // Combine pages and show row data
  const rows: OutlierItemType[] = [];
  if (data) {
    data.pages.forEach((page) => {
      const records: OutlierItemType[] = get(page, ['feeds'], []) as OutlierItemType[];
      rows.push(...records);
    });
  }

  return {
    isLoading,
    rows,
    isError,
    refetch,
    fetchNextPage,
    isFetchingNextPage,
    searchText,
    onSearch: setSearchText,
  };
}

export default useFetchArchivedOutliers;
